(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const main = section.querySelector('[data-main-image]');
      const thumbs = [...section.querySelectorAll('button[data-image]')];
      function showImage(src, alt, srcset) {
        if (!main || !src) return;
        if (srcset) main.srcset = srcset;
        else main.removeAttribute('srcset');
        main.src = src;
        main.alt = alt || main.alt;
        thumbs.forEach(button => {
          const active = button.dataset.image === src;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
      thumbs.forEach(button => button.addEventListener('click', () => showImage(button.dataset.image, button.dataset.alt, button.dataset.srcset)));
      const pairForm = section.querySelector('[data-pair-form]');
      if (pairForm && window.fetch && window.FormData) {
        pairForm.addEventListener('submit', async event => {
          event.preventDefault();
          if (pairForm.dataset.submitting === 'true') return;
          pairForm.dataset.submitting = 'true';
          const button = pairForm.querySelector('[data-pair-button]');
          const status = pairForm.querySelector('[data-pair-status]');
          const cartLink = pairForm.querySelector('[data-pair-cart-link]');
          const idleText = button.textContent;
          button.disabled = true;
          button.textContent = pairForm.dataset.addingText;
          status.hidden = true;
          cartLink.hidden = true;
          try {
            const response = await fetch(pairForm.dataset.addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
              body: new FormData(pairForm)
            });
            const result = await response.json();
            if (!response.ok || result.status >= 400) {
              throw new Error(pairForm.dataset.errorText);
            }
            window.location.assign(pairForm.dataset.cartUrl);
          } catch (error) {
            status.textContent = pairForm.dataset.errorText;
            status.hidden = false;
            cartLink.hidden = false;
            button.disabled = false;
            button.textContent = idleText;
            pairForm.dataset.submitting = 'false';
          }
        });
      }
      const select = section.querySelector('[data-variant-select]');
      if (!select) return;
      const purchaseOptions = section.querySelector('[data-purchase-options]');
      const singleForm = section.querySelector('.product-form');
      const pairOffer = section.querySelector('.pair-offer');
      let purchaseMode = 'single';
      if (purchaseOptions && singleForm && pairOffer) {
        section.classList.add('purchase-enhanced');
        purchaseOptions.hidden = false;
        const radios = [...purchaseOptions.querySelectorAll('input[type="radio"]')];
        function setPurchaseMode(value) {
          if (pairForm?.dataset.submitting === 'true') {
            radios.forEach(radio => { radio.checked = radio.value === purchaseMode; });
            return;
          }
          purchaseMode = value;
          singleForm.hidden = value === 'duo';
          pairOffer.hidden = value !== 'duo';
          const quantity = singleForm.querySelector('input[name="quantity"]');
          if (quantity) quantity.value = '1';
          const priceText = value === 'duo'
            ? radios.find(radio => radio.value === 'duo').dataset.price
            : select.selectedOptions[0].dataset.price;
          const mobilePrice = section.querySelector('[data-mobile-price]');
          if (mobilePrice) mobilePrice.textContent = priceText;
        }
        radios.forEach(radio => radio.addEventListener('change', () => {
          if (radio.checked) setPurchaseMode(radio.value);
        }));
        // Reset browser-restored radio state to match the visible form.
        radios.forEach(radio => { radio.checked = radio.value === 'single'; });
        setPurchaseMode('single');
      }
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = section.querySelector('[data-price]');
        const mobilePrice = section.querySelector('[data-mobile-price]');
        const button = section.querySelector('[data-add-button]');
        if (price) price.textContent = option.dataset.price;
        if (mobilePrice && purchaseMode === 'single') mobilePrice.textContent = option.dataset.price;
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
        }
        showImage(option.dataset.image, option.dataset.alt, option.dataset.srcset);
        if (location.pathname.includes('/products/')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState({}, '', url);
        }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
